// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import { Box, Container, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Slider from 'react-slick';

const customerData = [
  {
    name: 'ROSSMANN',
    src: '/assets/customers/rossmann.png',
  },
  {
    name: 'QUALITY GROUP',
    src: '/assets/customers/qualitygroup.png',
  },
  {
    name: 'STASTISTA',
    src: '/assets/customers/statista.svg',
  },
  {
    name: 'STAXTER',
    src: '/assets/customers/staxter.png',
  },
  {
    name: 'WEBVISUM',
    src: '/assets/customers/webvisum.png',
  },
  {
    name: 'POLYTEIA',
    src: '/assets/customers/polyteia.svg',
  },
];

function Customers() {
  const theme = useTheme();

  const carouselSettings = {
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    rtl: Boolean(theme.direction === 'rtl'),
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 0,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: theme.breakpoints.values.md,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: theme.breakpoints.values.sm,
        settings: { slidesToShow: 2 },
      },
    ],
  };

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <Container maxWidth="xl">
        <Stack px={{ md: '130px' }} py="100px">
          <Slider {...carouselSettings}>
            {customerData.map((customer) => (
              <Box key={customer.name} sx={{ px: 1.5 }}>
                <Box
                  key={customer.name}
                  component="img"
                  src={customer.src}
                  alt={customer.name}
                  sx={{
                    width: '150px',
                    maxWidth: '300px',
                    height: 'auto',
                    p: 2,
                    border: 1,
                    borderRadius: 1,
                  }}
                />
              </Box>
            ))}
          </Slider>
        </Stack>
      </Container>
    </Box>
  );
}

export default Customers;
